import type { ConnectionRequest, operations } from '..';
import { api } from '../api';
import { provider, tags } from '../tags';

export type CreateConnectionRequestArgs = {
  data: operations['createConnectionRequest']['requestBody']['content']['application/json'];
};

export type UpdateConnectionRequestArgs = {
  // Intentional dropping of most fields for updates
  status: operations['updateConnectionRequest']['requestBody']['content']['application/json']['status'];
  id: string;
  ignore_reason?: operations['updateConnectionRequest']['requestBody']['content']['application/json']['ignore_reason'];
  ignore_comment?: string;
};

export const connectionRequestsApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    connectionRequest: builder.query<ConnectionRequest, string>({
      query: (id: string) => `api/expert-network/connection-request/${id}/`,
      providesTags: provider<ConnectionRequest>(tags.connectionRequest),
    }),

    connectionRequests: builder.query<Array<ConnectionRequest>, void>({
      query: () => 'api/expert-network/connection-request/',
      providesTags: provider<ConnectionRequest>(tags.connectionRequest),
    }),

    createConnectionRequest: builder.mutation<ConnectionRequest, CreateConnectionRequestArgs>({
      query: ({ data }) => ({
        url: 'api/expert-network/connection-request/',
        body: data,
        method: 'POST',
      }),
      invalidatesTags: [tags.connectionRequest],
    }),

    updateConnectionRequest: builder.mutation<ConnectionRequest, UpdateConnectionRequestArgs>({
      query: ({ status, id, ignore_reason, ignore_comment }) => ({
        url: `api/expert-network/connection-request/${id}/`,
        body: { status, ignore_reason, ignore_comment },
        method: 'PATCH',
      }),
      invalidatesTags: [tags.connectionRequest],
    }),
  }),
});
